import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { AuthorityNumbersSection } from '../components/sections/AuthorityNumbersSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { BonusSection } from '../components/sections/BonusSection';
import { ScarcitySection } from '../components/sections/ScarcitySection';
import { ValueAnchorSection } from '../components/sections/ValueAnchorSection';
import { PricingSection } from '../components/sections/PricingSection';
import { OfferBlock } from '../components/sections/OfferBlock';
import { TestimonialSection } from '../components/sections/TestimonialSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FAQSection } from '../components/sections/FAQSection';
import { ClosingSection } from '../components/sections/ClosingSection';
import { FooterSection } from '../components/sections/FooterSection';
import { SocialProofPopup } from '../components/ui/SocialProofPopup';
export function LandingPage() {
  return <main className="min-h-screen bg-background-dark text-gray-300 font-body selection:bg-primary/30 selection:text-white" data-id="element-444">
      <HeroSection data-id="element-445" />
      <ProblemSection data-id="element-446" />
      <AuthorityNumbersSection data-id="element-447" />
      <SolutionSection data-id="element-448" />
      <BenefitsSection data-id="element-449" />
      <BonusSection data-id="element-450" />
      <ScarcitySection data-id="element-451" />
      <ValueAnchorSection data-id="element-452" />
      <PricingSection data-id="element-453" />
      <OfferBlock data-id="element-454" />
      <TestimonialSection data-id="element-455" />
      <GuaranteeSection data-id="element-456" />
      <FAQSection data-id="element-457" />
      <ClosingSection data-id="element-458" />
      <FooterSection data-id="element-459" />
      <SocialProofPopup data-id="element-460" />
    </main>;
}